// React

// Material UI
import { IconButton } from '@mui/material';

// Icons
import { Close } from '@mui/icons-material';

// Redux
import { useDispatch } from 'react-redux';
import { setIsCalendarVisible } from '../../../../../store/calendarSlice';

const BackButton = () => {
  const dispatch = useDispatch();

  return (
    <IconButton disableRipple onClick={() => dispatch(setIsCalendarVisible(false))}>
      <Close></Close>
    </IconButton>
  );
};

export default BackButton;
